import { useContext } from "react";
import { AddSizeChartContext } from "../../../Context/AddSizeChartContext";
import { showToast } from '../../../Components/Toaster/Toaster';

function FormInputSection({ externalCSS, centimeters, row_id, inches, spec, isLast }) {
    const { sizeChartFormData, setSizeChartFormData } = useContext(AddSizeChartContext);

    const handleInputChange = (id, field, unit = null, value) => {
        if(value >= 0) {
            const updatedData = sizeChartFormData.map((item) => {
                if (item.id === id) {
                    if (unit) {
                        return {
                            ...item,
                            [field]: { ...item[field], [unit]: value }
                        };
                    } else {
                        return { ...item, [field]: value };
                    }
                }
                return item;
            });

            setSizeChartFormData(updatedData);
        }
        else {
            showToast('Please enter a valid positive value.', 'warning');
            return;
        }
    };

    return (
        <div className={`w-[180px] flex items-center ${!isLast && 'border-r border-[#EAEAEA]'}`}>
            <div className="w-1/2 px-4 py-3 border-r border-[#EAEAEA]">
                <input 
                    type="number" 
                    name={`${spec}_cm`}
                    value={centimeters}
                    onChange={(e) => handleInputChange(row_id, spec, 'cm', e.target.value)} 
                    placeholder="cm" 
                    className="w-full outline-none placeholder:text-center text-center"
                />
            </div>

            <div className="w-1/2 px-6 py-3">
                <input 
                    type="number" 
                    name={`${spec}_in`}
                    value={inches}
                    onChange={(e) => handleInputChange(row_id, spec, 'in', e.target.value)} 
                    placeholder="in" 
                    className="w-full outline-none placeholder:text-center text-center"
                />
            </div>
        </div>
    )
}

export default FormInputSection;
